import axios from "../../axios";
import { GET_LIST_INVOICE_BY_CUSTOMER , SEND_INVOICE} from './invoiceTypes'
import { URL_GET_LIST_INVOICE_BY_CUSTOMER , URL_SEND_INVOICE} from './invoiceUrls'
import { ResponseModel, STATUS_OK } from '../../models/network/response_model'
export default {
// eslint-disable-next-line
  [GET_LIST_INVOICE_BY_CUSTOMER]({ commit }, item) {
    let param = new URLSearchParams(item).toString();
    return new Promise((resolve, reject) => {
      axios.get(`${URL_GET_LIST_INVOICE_BY_CUSTOMER}${param}`)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if(responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if(resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              commit(GET_LIST_INVOICE_BY_CUSTOMER, data);
              // console.log(data);
              resolve(data);
            } else {
              commit(GET_LIST_INVOICE_BY_CUSTOMER, {items: [], _links: {}, _meta: {}});
              resolve({items: [], _links: {}, _meta: {}});
            }
          } else {
            commit(GET_LIST_INVOICE_BY_CUSTOMER, {items: [], _links: {}, _meta: {}});
            resolve({items: [], _links: {}, _meta: {}});
          }
        })
        .catch((error) => { reject(error);})
      })
  },

  // eslint-disable-next-line
  [SEND_INVOICE]({ dispatch }, item) {
    return new Promise((resolve, reject) => {
      let data = new FormData();
      for (var key in item) {
        data.append(key, item[key]);
      }
      axios.post(`${URL_SEND_INVOICE}`, data)
        .then((response) => {
          let responseModel = new ResponseModel(response);
          if (responseModel.status == STATUS_OK) {
            let resultModel = responseModel.result;
            if (resultModel.status == STATUS_OK) {
              let data = resultModel.data;
              resolve(data);
            } else {
              reject(resultModel.message);
            }
          } else {
            reject(responseModel.message);
          }
        })
        .catch((error) => { reject(error) });
    })
  },
}
